<template>
  <div class="sync-modal">
    <div v-if="currentStep === 1">
      <div class="modal-title">On-Demand Sync</div>
      <div class="property-select">Property:</div>
      <div>
        <multiselect
          v-model="selectedProperty"
          placeholder="Select Property"
          :options="properties"
          label="name"
          track-by="uuid"
          :maxHeight="200"
          :allowEmpty="false"
          deselectLabel=""
          @select="getRooms"
        ></multiselect>
      </div>
      <div class="sync-select-wrapper" v-if="rooms.length > 0">
        <div class="sync-select-info">Select the rooms that you want sync:</div>
        <div class="checkbox-wrapper">
          <div class="top-checkbox-wrapper">
            <div class="all-checkbox-wrapper">
              <input
                type="checkbox"
                v-model="selectedAll"
                @change="onSelectAll"
              />
              <label class="room-name">Select all rooms</label>
            </div>
            <div class="total-room-selected">
              {{ checkedRooms.length }} rooms selected
            </div>
          </div>
          <div>
            <div
              v-for="(item, index) in rooms"
              class="room-checkbox-wrapper"
              :key="`room-checkbox-${index}`"
            >
              <input
                type="checkbox"
                :value="item.uuid + ':' + item.uplistingId"
                @change="roomCheckboxInput"
                v-model="checkedRooms"
              />
              <label class="room-name">{{ item.name }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-wrapper">
        <button class="footer-btn cancel" @click="hideModal">Cancel</button>
        <button class="footer-btn sync" @click="goSync">Sync</button>
      </div>
    </div>
    <div v-else-if="currentStep === 2">
      <div class="progress-number">{{ value }}%</div>
      <progress-bar :options="progressBarOptions" :value="value" />
      <div class="progress-info">Please wait while the rooms are syncing</div>
    </div>
    <div v-else>
      <div class="modal-title">On-Demand Sync</div>
      <div class="finish-info">
        <div>
          <img :src="require('@/assets/green-circle-check.svg')" />
        </div>
        <div>The rooms have been synced succesfully.</div>
      </div>
      <div class="text-right">
        <button class="footer-btn sync" @click="reloadPage">Accept</button>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import calls from '@/api/calls'
import ProgressBar from 'vuejs-progress-bar'

export default {
  components: {
    Multiselect,
    ProgressBar
  },
  props: {
    properties: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedProperty: null,
      rooms: [],
      checkedRooms: [],
      selectedAll: false,
      currentStep: 1,
      value: 65,
      progressBarOptions: {
        layout: {
          height: 32,
          width: 400,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        },
        text: {
          hideText: true
        },
        progress: {
          color: '#66B015',
          backgroundColor: '#F5F6FA',
          inverted: false
        }
      }
    }
  },
  methods: {
    resetData() {
      this.selectedProperty = null
      this.rooms = []
      this.checkedRooms = []
      this.selectedAll = false
      this.currentStep = 1
    },
    async getRooms(value) {
      this.resetData()
      const data = await calls.GET('properties/rooms', value.uuid)
      this.rooms = data.data
      this.selectedProperty = value
    },
    reloadPage() {
      window.location.reload()
    },
    hideModal() {
      this.resetData()
      this.$emit('hideModal')
    },
    roomCheckboxInput() {
      if (this.checkedRooms.length !== this.rooms.length) {
        this.selectedAll = false
      } else if (this.checkedRooms.length === this.rooms.length) {
        this.selectedAll = true
      }
    },
    onSelectAll(event) {
      const isChecked = event.target.checked
      if (isChecked) {
        this.checkedRooms = this.rooms.map((a) => a.uuid + ':' + a.uplistingId)
      } else {
        this.checkedRooms = []
      }
    },
    async goSync() {
      this.$emit('sync-state', true)
      this.currentStep += 1
      try {
        const { message, data } = await calls.POST('rooms/syncUplisting', {
          rooms: this.checkedRooms,
          propertyId: this.selectedProperty.uuid
        })
        if (message) {
          this.$notify({
            group: 'rent-mgt-notification',
            type: 'error',
            text: message
          })
          this.currentStep += 1
        } else {
          this.currentStep += 1
          return data
        }
      } finally {
        this.$emit('sync-state', false)
      }
    }
  }
}
</script>

<style scoped>
.sync-modal {
  text-align: left;
  margin: 24px;
  font-size: 14px;
}
.modal-title {
  font-weight: 800;
  font-size: 14px;
  color: #66b015;
}
.property-select {
  font-weight: 400;
  font-size: 14px;
  color: #192a3e;
  margin: 16px 0;
}
.footer-wrapper {
  display: flex;
  align-items: center;
  justify-content: end;
  margin: 32px 0 16px;
  gap: 8px;
}
.footer-btn {
  padding: 12px 16px;
  width: 120px;
  border: 1px solid #66b015;
  border-radius: 4px;
}
.footer-btn.cancel {
  background: #fff;
  color: #66b015;
}
.footer-btn.sync {
  background: #66b015;
  color: #fff;
}
.sync-select-wrapper {
  font-weight: 400;
  font-size: 14px;
  color: #4a4a4a;
}
.sync-select-info {
  margin-top: 32px;
}
.checkbox-wrapper {
  margin: 13px 0;
}
.room-checkbox-wrapper {
  background: #f6f8fa;
  border-bottom: 1px solid #dadada;
  padding: 10px;
}
.room-checkbox-wrapper:first-child {
  border-top: 1px solid #dadada;
}
.all-checkbox-wrapper {
  padding: 10px 0;
}
.top-checkbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}
.total-room-selected {
  background: #f0f8e8;
  border-radius: 4px;
  padding: 4px 8px;
  font-weight: 900;
  font-size: 12px;
  color: #66b015;
}
.progress-info {
  font-weight: 400;
  font-size: 15px;
  text-align: center;
  color: #4a4a4a;
  margin: 18px 0;
}
.progress-number {
  text-align: center;
  font-weight: 700;
  font-size: 27px;
  color: #66b015;
  margin-bottom: 8px;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.finish-info {
  border-top: 0.5px solid #d8dee4;
  border-bottom: 0.5px solid #d8dee4;
  padding: 24px;
  font-weight: 900;
  font-size: 13px;
  color: #192a3e;
  margin: 24px -24px;
  display: flex;
  align-items: center;
  gap: 24px;
}
.multiselect__element {
  font-size: 14px;
}
.multiselect__single {
  font-size: 14px;
}
.room-name {
  padding-left: 10px;
  top: -1px;
  position: relative;
}
::v-deep .multiselect__option {
  min-height: unset;
}
::v-deep .multiselect__tags {
  padding: 8px 8px 0 8px;
  min-height: unset;
}
::v-deep .multiselect__content-wrapper {
  position: relative;
}
</style>
